// these two are used to decide which files should be selectable when clicking on "image icon" vs "file icon"
export const supportedMimeTypesImg = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif']
export const supportedMimeTypesFile = ['application/pdf']

// filetypes that the upload function accepts
export const supportedMimeTypesToSend = [...supportedMimeTypesImg, ...supportedMimeTypesFile]

// filetypes that we accept to show in the chat
export const supportedMimeTypesToShow = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'image/gif',
  'image/x-ms-bmp',
  'image/tiff',
  'text/plain',
  'application/pdf',
  'application/rtf',
]
